/**
 * Action footers advance multi-step flows or save & submit information on a view.
 * They appear at the bottom of modals or individual content views.
 * On mobile this component's CSS will auto expand the right button 100%
 *
 * Examples:
 * https://www.figma.com/file/YSnmyD6DN3wnEnjbquUaNCX6/Haven-Design-System
 *
 * ```
 * Example:
 *   <div className={actionFooterStyles.container}>
 *     <BackButton color="secondary" size="L" />
 *     <div className={actionFooterStyles.spacer} />
 *     <Button size="L" color="primary">Next</Button>
 *   </div>
 * ```
 */
import styles from "./action-footer.module.css";
export const actionFooterStyles = styles;
